var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 55H27C26.4696 55 25.9609 54.7893 25.5858 54.4142C25.2107 54.0391 25 53.5304 25 53V26C25 25.7348 25.1054 25.4804 25.2929 25.2929C25.4804 25.1054 25.7348 25 26 25C26.2652 25 26.5196 25.1054 26.7071 25.2929C26.8946 25.4804 27 25.7348 27 26V53H54C54.2652 53 54.5196 53.1054 54.7071 53.2929C54.8946 53.4804 55 53.7348 55 54C55 54.2652 54.8946 54.5196 54.7071 54.7071C54.5196 54.8946 54.2652 55 54 55Z",
    fill: "#3671E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 51H31.25C30.6533 51 30.081 50.7629 29.659 50.341C29.2371 49.919 29 49.3467 29 48.75V39.25C29 38.6533 29.2371 38.081 29.659 37.659C30.081 37.2371 30.6533 37 31.25 37H33.75C34.3467 37 34.919 37.2371 35.341 37.659C35.7629 38.081 36 38.6533 36 39.25V48.75C36 49.3467 35.7629 49.919 35.341 50.341C34.919 50.7629 34.3467 51 33.75 51Z",
    fill: "#3671E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 51H40.25C39.6533 51 39.081 50.7629 38.659 50.341C38.2371 49.919 38 49.3467 38 48.75V36.25C38 35.6533 38.2371 35.081 38.659 34.659C39.081 34.2371 39.6533 34 40.25 34H42.75C43.3467 34 43.919 34.2371 44.341 34.659C44.7629 35.081 45 35.6533 45 36.25V48.75C45 49.3467 44.7629 49.919 44.341 50.341C43.919 50.7629 43.3467 51 42.75 51Z",
    fill: "#3671E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7274 51H49.2274C48.6307 51 48.0584 50.7629 47.6364 50.341C47.2145 49.919 46.9774 49.3467 46.9774 48.75V32.25C46.9774 31.6533 47.2145 31.081 47.6364 30.659C48.0584 30.2371 48.6307 30 49.2274 30H51.7274C52.3242 30 52.8965 30.2371 53.3184 30.659C53.7404 31.081 53.9774 31.6533 53.9774 32.25V48.75C53.9774 49.3467 53.7404 49.919 53.3184 50.341C52.8965 50.7629 52.3242 51 51.7274 51Z",
    fill: "#3671E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon-2.83dc4b222a04072cfb37e05c6e8c00b6.svg";
export { ForwardRef as ReactComponent };